const ACTION_TYPES = {
    SET_INITIALIZATION: 'SET_INITIALIZATION',
    SET_P13N_DATA_FOR_PREVIEW: 'SET_P13N_DATA_FOR_PREVIEW'
};

const initialState = {
    isInitialized: false
};

const reducer = function (state = initialState, { type, payload }) {
    switch (type) {
        case ACTION_TYPES.SET_INITIALIZATION:
            return Object.assign({}, state, {
                isInitialized: payload
            });

        case ACTION_TYPES.SET_P13N_DATA_FOR_PREVIEW:
            return Object.assign({}, state, {
                isInitialized: true,
                data: payload
            });

        default:
            return state;
    }
};

reducer.ACTION_TYPES = ACTION_TYPES;

module.exports = reducer;
